const clickPlan = () => {
  const currentPlan = document.querySelectorAll(".plan");

  currentPlan.forEach((plan) => {
    plan.addEventListener("click", (e) => {
      e.preventDefault();
      toggleClass()
      e.currentTarget.nextElementSibling.classList.add("tw-block");
      e.currentTarget.nextElementSibling.classList.remove("tw-hidden");
      e.currentTarget.classList.add('tw-border-[#E51473]')
      e.currentTarget.classList.remove("after:tw-content-['']", 'after:tw-absolute', 'after:tw-w-full', 'after:tw-h-full', 'after:tw-bg-black', 'after:tw-opacity-60', 'after:tw-top-0', 'after:tw-left-0')
      e.currentTarget.classList.remove('tw-border-black')
      e.currentTarget.classList.remove('tw-border-opacity-60')

      const selectedPlan = e.currentTarget.href.split('#')[1]
      const planDetail = document.getElementById(selectedPlan);
      planDetail.classList.add('md:tw-flex');
      planDetail.classList.remove('tw-hidden');

      const form = document.querySelectorAll('.form__main');
      const formTitle = document.querySelectorAll('.form__title');
      if (selectedPlan === 'teiki') {
        formTitle[0].classList.remove('tw-hidden');
        form[0].classList.remove('tw-hidden');
      } else if (selectedPlan === 'tanpin') {
        formTitle[1].classList.remove('tw-hidden');
        form[1].classList.remove('tw-hidden');
      }
    })
  })
}

const toggleClass = () => {
  const currentPlan = document.querySelectorAll(".plan");
  const planDetail = document.querySelectorAll('.plan__detail');
  const formTitle = document.querySelectorAll('.form__title');
  const form = document.querySelectorAll('.form__main');

  currentPlan.forEach((plan) => {
    plan.nextElementSibling.classList.add('tw-hidden')
    plan.classList.remove('tw-border-[#E51473]')
    plan.classList.add('tw-border-black')
    plan.classList.add('tw-border-opacity-60')
    plan.classList.add("after:tw-content-['']", 'after:tw-absolute', 'after:tw-w-full', 'after:tw-h-full', 'after:tw-bg-black', 'after:tw-opacity-60', 'after:tw-top-0', 'after:tw-left-0')
  })

  planDetail.forEach((planDetail) => {
    planDetail.classList.remove('md:tw-flex');
    planDetail.classList.add('tw-hidden');
  })

  formTitle.forEach((title) => {
    title.classList.add('tw-hidden');
  })

  form.forEach((f) => {
    f.classList.add('tw-hidden');
  })
}

clickPlan()